<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: wjx
 * @LastEditTime: 2019-07-17 10:45:20
 -->

<template>
  <div class="headline_box">
    <iframe
      id="show-iframe"
      frameborder="0"
      name="showHere"
      scrolling="auto"
      :src="iframeUrl"
      @load="loaded"
      style="width:100%;height:12rem;"
    ></iframe>
    <!-- <div class="footer" @click="show(1)">
        <swiper auto height="2.84rem" :interval=2000 :show-dots="true" dots-class="custom-bottom" dots-position="center">
            <swiper-item v-for="(item,index) in newList" :key="index" v-if="index<3">
                <img v-if='index==0' src="http://cdn.yxvzb.com/testBuild/qun2/top%20@2x.png" class="cover" />
                <img :src="item.pic" class="swipe_img"><span class="swipe_title">{{item.title}}</span>
            </swiper-item>
        </swiper>
    </div>-->
    <div class="qrBox" v-show="showFlag" @touchmove.prevent @click="hide">
      <img src="//cdn.yxvzb.com/testBuild/qun2/back.png" class="qrMain" />
      <!-- <img src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQEo8TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyczFSZlpFdmJmWDMxMDAwMGcwM2wAAgSKv3NaAwQAAAAA" class="qrCode" /> -->
      <p>关注医学V视界</p>
      <p>更多精彩随心看</p>
    </div>
    <span
      class="focus"
      @click="show(2)"
      style="width: 1rem;height: .59rem;border-radius: .08rem;background: linear-gradient(to right,#2EACFD,#027CFA);text-align: center;line-height:.59rem;color: #fff;display:inline-block"
    >
      关注
    </span>
    <fan></fan>
  </div>
</template>

<script>
import ListForImgAndText from '@/components/Headline/list.vue';
import fan from '@/components/fan.vue';
import { headline, shareCallback } from '@/api/ajax.js';

import { contentview } from '@/Mixin/contentview.js';
// TODO: vux
import {
  Confirm,
  TransferDomDirective as TransferDom,
  XButton,
  Swiper,
  SwiperItem
} from 'vux';
import { mapState, mapActions } from 'vuex';
export default {
  name: '',
  mixins: [contentview],
  directives: {
    TransferDom
  },
  data() {
    return {
      iframeUrl: '',
      detailObj: {},
      categoriesArr: [],
      listData: [],
      showSub: true, //  详情中的订阅
      showToPushInfo: false, // 用户内的订阅
      showBigPushInfo: false, // 订阅大弹层
      agin: false,
      isCollection: false,
      newList: [], // 午间资讯列表
      showFlag: false,
      detailType: 3
    };
  },
  methods: {
    ...mapActions(['wxUserInfoAction']),
    eventCollection(val) {
      this.isCollection = val;
    },
    goYsl() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    show(type) {
      scrollTo(0, 0);
      this.showFlag = true;
      if (type == 1) {
        sa.track('wx_fenxiangye_zixuntuijian', {}, function() {});
      } else if (type == 2) {
        sa.track('wx_fenxiangye_zixunguanzhu', {}, function() {});
      }
    },
    hide() {
      this.showFlag = false;
    },
    getDetail() {
      let data = {
        id: this.$route.params.id,
        type: this.$route.query.type
      };
      let request = 'detail';

      if (this.detailType == 2) {
        request = 'caseDetail';
      } else if (this.detailType == 8) {
        request = 'noteDetail';
      }

      headline[request](data).then(res => {
        let { detail, relationCourse, relationNews } = res.data.data;

        this.detailObj = detail;
        let iframeUrlSplit = detail.content.split('?');
        if (iframeUrlSplit.length > 1) {
          this.detailObj.content =
            (this.$config.protocol === 'https'
              ? iframeUrlSplit[0].replace(/http:/g, 'https:')
              : iframeUrlSplit[0]) +
            '?t=' +
            new Date().getTime();
        }
        this.iframeUrl = this.detailObj.content;
        // this.detailObj.type != 2 ? this.showBigPushInfo = true : this.showBigPushInfo = false
        this.listData = relationNews;
        //          this.relationCourseItems = res.data.data.relationCourseItems
        // this.isCollection = res.data.data.collection
        if (this.detailObj.subCategory) {
          this.showSub = false;
        }
        let wxUserInfo = this.wxUserInfo || {};
        let shareFlag = 'wx';
        let shareType = 'information';
        if (/shareFlag=true/.test(location.href)) {
          shareFlag = 'share';
        }
        if (this.$route.query.type == 2) {
          shareType = 'bingli';
        } else if (this.$route.query.type == 8) {
          shareType = 'tiezi';
        }
        sa.track(
          'caseDetail',
          {
            title: this.detailObj.title,
            type: shareType,
            pageUrl: location.href,
            from: shareFlag,
            editor: this.detailObj.editor || '',
            client_id: wxUserInfo.id || wxUserInfo.wxOpenId || '',
            distinctId: wxUserInfo.id || wxUserInfo.wxOpenId || '',
            web_edition: 2
          },
          function() {
            //   console.log(shareFlag)
          }
        );
        let newScType = '资讯';
        if (shareType == 'tiezi') {
          newScType = '帖子';
        } else if (shareType == 'bingli') {
          newScType = '病例';
        }
        this.pageStayTime(newScType);

        let oIframe = document.getElementById('show-iframe');

        let deviceWidth = document.documentElement.clientWidth;
        let deviceHeight = document.documentElement.clientHeight;
        oIframe.style.width = '10rem';
        oIframe.style.height = deviceHeight + 'px';
        //          oIframe.style.height = oIframe.contentDocument.body.scrollHeight+'px'

        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status != '0') {
              // 恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              // 您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            let wxUserInfo = this.wxUserInfo;
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: shareType,
                target: this.$route.params.id,
                client_id: wxUserInfo.id || wxUserInfo.wxOpenId || '',
                web_edition: 2
              },
              function() {}
            );

            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: this.detailObj.type, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: this.$route.params.id, // 内容id
              first_cate: '', // 一级分类
              second_cate: '', // 2级分类
              first_cate_id: '', // 1级分类id
              second_cate_id: '', // 2级分类id
              author: this.detailObj.editor || '', // 讲师/作者
              contentname: this.detailObj.title,
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };
        let shareUrl = location.href;
        if (!this.$route.query.shareFlag) {
          let splitUrlForHeaderDetail = shareUrl.split('headlineDetail/')[0];
          splitUrlForHeaderDetail += `headlineDetail/${this.$route.params.id}?shareFlag=true`;
          shareUrl = splitUrlForHeaderDetail;
          // if(splitUrlForHeaderDetail.length > 2) {
          //   shareUrl = shareUrl.replace('?shareFlag=true', '&shareFlag=true')
          // }else {
          //   shareUrl = shareUrl + `${this.$route.query.type || this.$route.query.isTemp ? '&' : '?'}shareFlag=true`
          // }
        }
        let sharePic =
          this.detailObj.converUrl ||
          'http://cdn.yxvzb.com/newWechat/image/logo98.png';
        this.$wxShareInfo(
          this.detailObj.title,
          this.detailObj.introduces,
          sharePic,
          location.href,
          shareUrl,
          shareCallBackFunc
        );
      });
    },
    fetchData() {
      location.reload();
      //        let oIframe = document.getElementById('show-iframe');
      //        let deviceWidth = document.documentElement.clientWidth;
      //        let deviceHeight = document.documentElement.clientHeight;
      //        oIframe.style.width = deviceWidth + 'px';
      //        oIframe.style.height = deviceHeight + 'px';
      //        this.getDetail()
    },
    subInformationRelationDepartment() {
      // 订阅按钮
      headline
        .subInformationRelationDepartment({
          id: this.$route.params.id
        })
        .then(res => {
          this.showSub = false;
          this.$vux.toast.show({
            text: '订阅成功',
            type: 'success',
            width: '5rem'
          });
        });
    },
    toPushInfo() {
      // 浮层订阅
      headline
        .toPushInfo({
          userId: this.wxUserInfo.id,
          status: this.agin ? 0 : 1
        })
        .then(res => {
          this.showToPushInfo = false;
          this.wxUserInfoAction(
            Object.assign(this.$api.getStorage('wxUserInfo'), {
              isRecieveInfoPush: 1
            })
          );
        });
    },
    onCancel() {
      this.showToPushInfo = false;
      if (this.agin) {
        headline
          .toPushInfo({
            userId: this.wxUserInfo.id,
            status: this.agin ? 0 : 1
          })
          .then(res => {
            this.wxUserInfoAction(
              Object.assign(this.$api.getStorage('wxUserInfo'), {
                isRecieveInfoPush: 1
              })
            );
          });
      }
    },
    loaded() {
      try {
        if (this.$api.kernel() == 'wx') {
          document
            .getElementById('show-iframe')
            .contentWindow.document.querySelector(
              '.topWxLoad'
            ).onclick = function() {
            window.location.href =
              'http://www.yxvzb.com/download?qudao=beiyong1';
          };
        }
        let oIframe = document.getElementById('show-iframe');
        oIframe.contentDocument.body.style.width = '9rem';
        oIframe.contentDocument.body.style.margin = 'auth';
        oIframe.style.height =
          Math.max(
            oIframe.contentDocument.body.clientHeight,
            oIframe.contentDocument.body.scrollHeight,
            oIframe.contentDocument.body.scrollTop,
            oIframe.contentWindow.document.documentElement.scrollHeight
          ) + 'px';
      } catch (e) {
        console.log('cuowu');
      }
      try {
        let oIframe = document.getElementById('show-iframe');
        let top = oIframe.contentDocument.getElementsByClassName(
          'topProvenance'
        )[0];
        let node = document.getElementsByClassName('focus')[0];
        if (top) {
          top.appendChild(node);
        }
      } catch (e) {
        console.log('跨域');
      }
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {
    ListForImgAndText,
    Confirm,
    XButton,
    Swiper,
    SwiperItem,
    fan
  },
  watch: {
    $route: 'fetchData',
    wxUserInfo(val) {
      val.isRecieveInfoPush == 1
        ? (this.showToPushInfo = false)
        : (this.showToPushInfo = true);
    }
  },
  created() {
    let iframeConnet = (type, id) => {
      let name = 'info';
      if (type == 2) {
        name = 'case';
      } else if (type == 8) {
        name = 'note';
      }
      return `http://cdn.yxvzb.com/static/content/${name}/${id}.html`;
    };
    this.detailType = this.$route.query.type;
    // 暂时不拼接
    // this.iframeUrl = iframeConnet(this.detailType, this.$route.params.id)

    // TODO: 老接口没有了
    // headline.getShare({}).then(res => {
    //     this.newList = res.data.dailyInformation[0].dailyInfor
    // })
    let that = this;
    window.previewImageEvent = function(aa) {
      let ar = [];
      ar.push(aa);
      that.$wechat.previewImage({
        current: aa,
        urls: ar
      });
    };
  },
  mounted() {
    // this.wxUserInfo.isRecieveInfoPush == 1 ? this.showToPushInfo = false : this.showToPushInfo = true
    this.getDetail();
  }
};
</script>
<style lang="less">
.footer {
  .vux-slider > .vux-indicator,
  .vux-slider .vux-indicator-right {
    bottom: 1.25rem !important;
  }
  .vux-icon-dot.active {
    background: #027cfa !important;
    width: 0.29rem !important;
    height: 0.2rem !important;
    border-radius: 0.1rem !important;
  }
}
</style>
<style scoped lang="less">
.focus {
  width: 1.44rem;
  height: 0.59rem;
  border-radius: 0.08rem;
  background: linear-gradient(to right, #2eacfd, #027cfa);
  margin-left: 0.4rem;
  text-align: center;
  line-height: 0.59rem;
  color: #fff;
  display: none !important;
}

.openYsl {
  width: 9.2rem;
  height: 1.04rem;
  margin: 0.4rem auto;
  background: #027cfa;
  border-radius: 3px;
  font-size: 0.4rem;
  color: #ffffff;
  line-height: 1.6rem;
}

.pTitle {
  font-size: 0.3733rem;
}

.notPrompt {
}

.headline_box {
  width: 100%;
  .weui-btn_primary {
    background-color: #027cfa;
    padding: 0.2rem 0;
    margin: 0.2rem 0;
  }
}

.qrBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  .qrMain {
    width: 7.87rem;
    height: 9.68rem;
    margin: 0 auto;
    margin-top: 1.47rem;
    display: block;
  }
  // .qrCode{
  //   width: 3.95rem;
  //   height: 3.95rem;
  //   position: absolute;
  //   top: 4.83rem;
  //   left: 3.03rem;
  // }
  p:first-of-type {
    font-size: 0.45rem;
    color: #027cfa;
    line-height: 1;
    position: absolute;
    top: 9.3rem;
    text-align: center;
    width: 100%;
  }
  p:last-of-type {
    position: absolute;
    top: 10.2rem;
    font-size: 0.4rem;
    color: #161616;
    text-align: center;
    width: 100%;
    line-height: 1;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  height: 1.71rem;
  width: 100%;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0.4rem;
  padding-top: 0.13rem;
  padding-right: 0.4rem;
  background: #fff;
  .cover {
    position: absolute;
    left: 0;
    top: 0;
    width: 1.07rem;
    height: 1.07rem;
  }
  .swipe_img {
    width: 2.16rem;
    height: 1.44rem;
    float: left;
    margin-right: 0.27rem;
  }
  .swipe_title {
    float: left;
    font-size: 0.37rem;
    color: #191919;
    width: 6rem;
  }
}
</style>
